'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var LayoutView = require('base/Colido.LayoutView');
var ImportUnfinishedList = require('../partials/import-unfinished-list');
var ImportRecentList = require('../partials/import-recent-list');

var template = require('../../templates/layout/imports.hbs');

var ImportsLayout = LayoutView.extend({
    template: template,

    className: 'settings settings-import',

    ui: {
        importAbort:  '[data-action="abort"]',
    },

    events: {
        'click @ui.importAbort': 'importAbort',
    },

    regions: {
        unfinishedImportsRegion: '#region-unfinished-imports',
        recentImportsRegion: '#region-recent-imports',
    },

    /**
     * Collection for the unfinished items
     * @type {Colido.Collection}
     */
    collectionUnfinished: null,

    /**
     * Collection for the finished items
     * @type {Colido.Collection}
     */
    collectionFinished: null,

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, arguments);

        this.collectionUnfinished = this.collection.unfinished();
        this.collectionFinished = this.collection.finished();

        this.listenTo(this.collectionUnfinished, 'add remove sync change', this.checkListRegions.bind(this));
        this.listenTo(this.collectionFinished, 'add remove sync change', this.checkListRegions.bind(this));
    },

    onBeforeShow: function() {
        this.unfinishedImportsRegion.show(new ImportUnfinishedList({
            collection: this.collectionUnfinished,
        }));

        this.recentImportsRegion.show(new ImportRecentList({
            collection: this.collectionFinished,
        }));

        this.checkListRegions();
    },

    viewData: {
        importsPath: function() { return '/catalogs/' + this.collection.catalog.id + '/import'; },
    },

    /**
     * Action for aborting an import
     * @param event
     */
    importAbort: function(event) {
        var $button = $(event.currentTarget);
        var id = $(event.currentTarget).data('id');

        $button.addClass('is-loading');
        $button.removeClass('is-loading');
        //@todo not implemented
        console.log('importAbort not implemented yet');
    },

    /**
     * Checks, if the regions with the lists should be shown
     */
    checkListRegions: function() {
        this.collection.sortByFields();
        this.$el.toggleClass('has-unfinished', this.collectionUnfinished.length > 0);
        this.$el.toggleClass('has-finished', this.collectionFinished.length > 0);
    },
});

module.exports = ImportsLayout;